import * as React from 'react';
import { useParams } from 'react-router-dom';
import { PageTitle } from '../../../../widgets/PageTitle';
import Panel from '../../../../widgets/Panel';
import VerticalWizard from '../../../../widgets/VerticalWizard';
import { AppSelection } from './AppSelection';
import { AddNewAccount } from './AddNewAccount';
import { SubmissionReview } from './SubmissionReview';
import Viewport from '../../../../widgets/Viewport';
import { CredentialSecret } from '../../../../types';
import { ConnectedAccountPageHeader } from '../ConnectedAccountPageHeader';

const ConnectedAccountAddNewView = () => {
  const { type } = useParams<{ type: string }>();

  const [step, setStep] = React.useState(type ? 2 : 1);
  const [submitted, setSubmitted] = React.useState<CredentialSecret | null>(
    null,
  );

  React.useEffect(() => {
    if (type) {
      if (step === 1) {
        setStep(2);
      }
    } else if (step !== 1) {
      setStep(1);
    }
  }, [step, type]);

  const onSubmitSuccess = React.useCallback(
    (newCredential: CredentialSecret) => {
      setSubmitted(newCredential);
      setStep(3);
    },
    [],
  );

  return (
    <Viewport>
      <PageTitle title="New Account" />
      <ConnectedAccountPageHeader title="Add Account" />
      <Panel className="min-height-for-loading-indicator p-5">
        <VerticalWizard step={step}>
          <VerticalWizard.Step title="Select a cloud application">
            <AppSelection />
          </VerticalWizard.Step>

          <VerticalWizard.Step title="Submit your account information">
            {type && <AddNewAccount onSuccess={onSubmitSuccess} />}
          </VerticalWizard.Step>

          <VerticalWizard.Step title="Review your submission">
            {submitted && <SubmissionReview credential={submitted} />}
          </VerticalWizard.Step>
        </VerticalWizard>
      </Panel>
    </Viewport>
  );
};

export default ConnectedAccountAddNewView;
